import type { CSSProperties } from 'react';
import { assetUrl } from '../../assets/manifest';
import ui from './ui.module.css';

/** The snow arena, as a darkened backdrop (menus use the 2048 px version). */
export const ARENA_IMAGE = 'generated/arenas/snow_2048.webp';

const FILTERS = {
  hero: 'brightness(.5) saturate(.8)',
  menu: 'brightness(.35) saturate(.7)',
  vs: 'brightness(.4) saturate(.7)',
  loss: 'brightness(.22) saturate(.3) blur(2px)',
  popup: 'brightness(.18) saturate(.5) blur(3px)',
} as const;

export type BackdropTone = keyof typeof FILTERS;

/**
 * An absolutely positioned arena image with a shade on top. `shade` is a CSS background
 * (gradients from the designs); the parent must be positioned.
 */
export function ArenaBackdrop({
  tone,
  shade,
  className,
  style,
}: {
  tone: BackdropTone;
  shade?: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div className={[ui.backdrop, className ?? ''].join(' ')} style={style} aria-hidden="true">
      <img className={ui.backdropImg} src={assetUrl(ARENA_IMAGE)} alt="" style={{ filter: FILTERS[tone] }} draggable={false} />
      {shade && <div className={ui.backdropShade} style={{ background: shade }} />}
    </div>
  );
}

/** Slowly turning rays (amber or green) behind winners and popups. */
export function Rays({ size, color, top = '50%', className }: { size: number; color: string; top?: string; className?: string }) {
  const style = { width: size, height: size, top, '--ray': color } as CSSProperties;
  return <div className={[ui.rays, className ?? ''].join(' ')} style={style} aria-hidden="true" />;
}
